import React from "react";
import { Box } from "@material-ui/core";
export const MarkerDialog = ({ visible, children }) => {
    return visible ? (React.createElement(Box, { role: "dialog", position: "absolute", right: -4, top: -4, zIndex: 1, bgcolor: "background.paper", borderRadius: 28, boxShadow: 4, minWidth: 280, pt: 2, p: 3 }, children)) : null;
};
